var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip-logo)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.001 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.223 4.643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.989,2.827S25.351.358,15.912.358h0C6.469.358.83,2.827.83,2.827S.325,13.76,2.465,19.942A22.854,22.854,0,0,0,15.907,33.865h.006A22.859,22.859,0,0,0,29.355,19.942C31.5,13.76,30.989,2.827,30.989,2.827Z",
    fill: "red"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.93,12.252v6.024H18.9V25.3H12.878V18.276H5.85V12.252h7.028V5.226H18.9v7.026Z",
    transform: "translate(3.223 4.643)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.836c7a79303992bb23ab763373de91d3.svg";
export { ForwardRef as ReactComponent };